import loader from '../../common/loader';
import { loginCookie } from '../login/common';
var jsApi = 'https://game.gtimg.cn/images/js/milo-utils/easykit/4.1.9/easy-kit.min.js';
var miloSelfConfig = {
  isMiloWayCookies: false,
  appName: 'ac'
};

var loadJsApi = function loadJsApi() {
  return new Promise(function (resolve) {
    var _window, _window$ek;

    console.log('call ac jsBridge');

    if ((_window = window) !== null && _window !== void 0 && (_window$ek = _window.ek) !== null && _window$ek !== void 0 && _window$ek.ac) {
      console.log('window.ek.ac', window.ek.ac);
      resolve(window.ek.ac);
      return;
    }

    loader.loadScript(jsApi).then(function (isLoad) {
      console.log('加载', jsApi);

      if (isLoad && window.ek.ac) {
        console.log('window.ek.ac', window.ek.ac);
        resolve(window.ek.ac);
      } else {
        reject();
      }
    })["catch"](function (e) {
      reject(e);
    });
  });
};

var loginByQQAndWX = function loginByQQAndWX() {
  loadJsApi().then(function (JsBridge) {
    JsBridge.User.Login({}, function (res) {
      // 唤起登录结果
      var status = res.status;

      if (status == 2) {
        window.location.reload();
      }
    });
  })["catch"](function (e) {
    console.log(e);
  });
};

var loginByWX = function loginByWX() {
  loadJsApi().then(function (JsBridge) {
    JsBridge.User.Login({
      login_type: 2
    }, function (res) {
      var status = res.status;

      if (status == 2) {
        window.location.reload();
      }
    });
  })["catch"](function (e) {
    console.log(e);
  });
};

var loginByQQ = function loginByQQ() {
  loadJsApi().then(function (JsBridge) {
    JsBridge.User.Login({
      login_type: 1
    }, function (res) {
      var status = res.status;

      if (status == 2) {
        window.location.reload();
      }
    });
  })["catch"](function (e) {
    console.log(e);
  });
};

var setAppCookie = function setAppCookie() {
  console.log('beforeSetCookie');
  return new Promise(function (resolve) {
    loadJsApi().then(function (JsBridge) {
      JsBridge.User.GetUserInfo({
        channel_id: ""
      }, function (res) {
        if ((res === null || res === void 0 ? void 0 : res.status) == 2) {
          var _res$data, _res$data5;

          if ((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.login_type) == 2) {
            var _res$data2, _res$data3, _res$data4;

            loginCookie.setLocal({
              acctype: 'wx',
              appid: (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.appid,
              openid: (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.openid,
              access_token: (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.access_token
            }, 7200);
          }

          if ((res === null || res === void 0 ? void 0 : (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.login_type) == 4) {
            var _res$data6, _res$data7, _res$data8;

            window.iUseQQConnect = 1;
            loginCookie.setLocal({
              acctype: 'qc',
              appid: (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.appid,
              openid: (_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : _res$data7.openid,
              access_token: (_res$data8 = res.data) === null || _res$data8 === void 0 ? void 0 : _res$data8.access_token
            }, 7200);
          }

          resolve();
        } else {
          reject();
        }
      });
    })["catch"](function (e) {
      console.log('err', e);
      reject();
    });
  });
};

var getLoginType = function getLoginType() {
  return new Promise(function (resolve) {
    loadJsApi().then(function (JsBridge) {
      JsBridge.User.GetUserInfo({
        channel_id: ""
      }, function (res) {
        if ((res === null || res === void 0 ? void 0 : res.status) == 2) {
          var _res$data9, _res$data10;

          if ((res === null || res === void 0 ? void 0 : (_res$data9 = res.data) === null || _res$data9 === void 0 ? void 0 : _res$data9.login_type) == 2) {
            resolve('wx');
          } else if ((res === null || res === void 0 ? void 0 : (_res$data10 = res.data) === null || _res$data10 === void 0 ? void 0 : _res$data10.login_type) == 4) {
            resolve('qc');
          } else {
            console.log('no tencent logintype');
            resolve(null);
          }
        } else {
          console.log('no tencent logintype');
          resolve(null);
        }
      });
    })["catch"](function (e) {
      console.log('err', e);
      resolve(null);
    });
  });
};

var logout = function logout() {
  loginCookie.clearLocal();
  loginCookie.clearQQ();
};

var tgclub = {
  loadJsApi: loadJsApi,
  loginByWX: loginByWX,
  loginByQQ: loginByQQ,
  loginByQQAndWX: loginByQQAndWX,
  setAppCookie: setAppCookie,
  getLoginType: getLoginType,
  logout: logout,
  miloSelfConfig: miloSelfConfig
};
export default tgclub;